import { render, staticRenderFns } from "./company-panel.vue?vue&type=template&id=28dd2118&scoped=true&"
import script from "./company-panel.vue?vue&type=script&lang=ts&"
export * from "./company-panel.vue?vue&type=script&lang=ts&"
import style0 from "./company-panel.vue?vue&type=style&index=0&id=28dd2118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28dd2118",
  null
  
)

export default component.exports